module.exports = __webpack_public_path__ + "assets/images/project/constituencies/hong-kah-north-smc.jpg?v=0000c8a2";